import script from "./navigationHeaderDesktop.vue?vue&type=script&setup=true&lang=js"
export * from "./navigationHeaderDesktop.vue?vue&type=script&setup=true&lang=js"

import "./navigationHeaderDesktop.vue?vue&type=style&index=0&id=4564dce4&lang=scss&scoped=true"

import exportComponent from "/home/dmytro/Projects/gcs/frontend/homepage/gc-schoenbuch/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4564dce4"]])

export default __exports__